import {useToast} from '@sttedra_ui/framework';

const toastService = useToast();
async function sucessCustom(msj) {
  return toastService.add({
    type: 'success', title: 'Operación realizada correctamente',
    message: msj?msj:
      'Operación realizada satisfactoriamente.', life: 4000,
    closable: true,
  });
}
async function infoCustom(msj) {
  return toastService.add({
    type: 'info', title: '',
    message: msj?msj:
      'Operación realizada satisfactoriamente.', life: 3000,
    closable: true,
  });
}

async function warningCustom(msj) {
  return toastService.add({
    type: 'warning', title: '',
    message: msj?msj:
      'Operación realizada satisfactoriamente.', life: 7000,
    closable: true,
  });
}

export {sucessCustom, infoCustom, warningCustom};
